import { theme } from '@ahmdigital/ui';
import Icon from '@ahmdigital/icons-web';

import { PaginationItem, PaginationLink } from '../../styles';
import constants from '../../../../ahm-constants';

const { URLS } = constants;
const { colors } = theme;

export const DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

type Props = {
  direction: (typeof DIRECTION)[keyof typeof DIRECTION];
  isDisabled: boolean;
  pageNumber: number;
};

const PaginationNavButton = ({ direction, isDisabled, pageNumber }: Props) => (
  <PaginationItem>
    <PaginationLink
      disabled={isDisabled}
      to={`${URLS.SALES.ARTICLE_HUB}?page=${pageNumber}`}
      aria-label={`Go to ${direction === DIRECTION.LEFT ? 'previous' : 'next'} page`}
    >
      <Icon name={`chevron-${direction}`} fill={isDisabled ? colors.grey30 : colors.black} />
    </PaginationLink>
  </PaginationItem>
);

export default PaginationNavButton;
